import React, { useEffect, useState, useRef } from "react";
import { fileService } from "@/api";
import "./SharedReportStyles.css";
import "./FirmasConformidad.css";
import DarphaLogo from "@/assets/darpha_logo_digital.png";
import DemoSignatureService from "@/services/DemoSignatureService";

const FirmasConformidad = ({
  seccion,
  reportInfo,
  onImagesLoaded = () => {},
}) => {
  const [plantImageUrl, setPlantImageUrl] = useState(null);
  const [inspectorSignature, setInspectorSignature] = useState(null);
  const [supervisorSignature, setSupervisorSignature] = useState(null);
  const inspectorImageRef = useRef(null);
  const supervisorImageRef = useRef(null);

  useEffect(() => {
    if (reportInfo.imagenplanta) {
      fetchImageUrl(reportInfo.imagenplanta).then((url) =>
        convertToBase64(url, setPlantImageUrl)
      );
    }

    // Manejar firma del inspector
    if (reportInfo.firmainspector) {
      // Verificar si es una firma local de demo
      if (
        DemoSignatureService.isLocalDemoSignature(reportInfo.firmainspector)
      ) {
        const localSignature = DemoSignatureService.getLocalSignatureImage(
          reportInfo.firmainspector
        );
        setInspectorSignature(localSignature);
      } else {
        fetchImageUrl(reportInfo.firmainspector).then((url) =>
          convertToBase64(url, setInspectorSignature)
        );
      }
    }

    // Manejar firma del supervisor
    if (reportInfo.firmasupervisor) {
      // Verificar si es una firma local de demo
      if (
        DemoSignatureService.isLocalDemoSignature(reportInfo.firmasupervisor)
      ) {
        const localSignature = DemoSignatureService.getLocalSignatureImage(
          reportInfo.firmasupervisor
        );
        setSupervisorSignature(localSignature);
      } else {
        fetchImageUrl(reportInfo.firmasupervisor).then((url) =>
          convertToBase64(url, setSupervisorSignature)
        );
      }
    }
  }, [
    reportInfo.imagenplanta,
    reportInfo.firmainspector,
    reportInfo.firmasupervisor,
  ]);

  useEffect(() => {
    if (inspectorImageRef.current && supervisorImageRef.current) {
      const handleImageLoad = () => {
        if (
          inspectorImageRef.current.complete &&
          supervisorImageRef.current.complete
        ) {
          onImagesLoaded();
        }
      };

      inspectorImageRef.current.onload = handleImageLoad;
      supervisorImageRef.current.onload = handleImageLoad;
    }
  }, [inspectorImageRef, supervisorImageRef, onImagesLoaded]);

  const fetchImageUrl = async (imagePath) => {
    try {
      // getImage espera imagePath en formato "folder/filename"
      const url = await fileService.getImage(imagePath);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };

  const convertToBase64 = (url, callback) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          callback(reader.result);
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error("Error converting image to base64:", error);
      });
  };

  return (
    <div className="sr-section">
      <p className="sr-section-title">{seccion.nombreseccion}</p>
      <div className="fc-firmas-conformidad">
        <div
          className="fc-firma-content"
          style={{ "--background-image": `url(${DarphaLogo})` }}
        >
          <strong>Inspector</strong>
          {inspectorSignature ? (
            <img
              src={inspectorSignature}
              alt="Firma Inspector"
              className="fc-firma"
              ref={inspectorImageRef}
            />
          ) : (
            <div className="fc-sin-firma">
              <span>Sin firma</span>
            </div>
          )}
          <span className="fc-divisor">_____________________</span>
          <span>{reportInfo.inspector}</span>
        </div>
        <div
          className="fc-firma-content"
          style={{ "--background-image": `url(${plantImageUrl})` }}
        >
          <strong>Supervisor</strong>
          {supervisorSignature ? (
            <img
              src={supervisorSignature}
              alt="Firma Supervisor"
              className="fc-firma"
              ref={supervisorImageRef}
            />
          ) : (
            <div className="fc-sin-firma">
              <span>Sin firma</span>
            </div>
          )}
          <span className="fc-divisor">_____________________</span>
          <span>{reportInfo.supervisor}</span>
        </div>
      </div>
    </div>
  );
};

export default FirmasConformidad;
